const logError = require('App/babel/helpers/logError').default;

angular.module('upsalesApp').controller('MainCtrl', [
	'$rootScope',
	'$scope',
	'security',
	'SearchService',
	'NotificationService',
	'$q',
	'AppService',
	'PushNotifications',
	'Scripts',
	'$cookies',
	'Product',
	'Ads',
	'ScriptService',
	'StandardIntegration',
	function (
		$rootScope,
		$scope,
		security,
		SearchService,
		NotificationService,
		$q,
		AppService,
		PushNotifications,
		Scripts,
		$cookies,
		Product,
		Ads,
		ScriptService,
		StandardIntegration
	) {
		const Store = require('Store').default;
		const openModal = require('App/services/Modal').default;
		const { setAIChatOpen, setLoading } = require('Store/actions/AppActions');

		var Main = this;

		Main.isLoggedIn = false;
		Main.loginWarningOpen = false;

		var clearData = function () {
			Main.agreementEnabled = false;
			Main.customerId = null;
			Main.isAdmin = 0;
			Main.isLoggedIn = false;
			Main.isMailAdmin = false;
			Main.licenses = 0;
			Main.listViews = {};
			Main.mailActivated = false;
			Main.self = {};
			Main.trackingActivated = false;
			Main.upsalesVersion = null;
			Main.userMultiSoliditet = false;
		};

		$scope.$on('listView.updated', function (e, updated) {
			var view = _.find(Main.listViews[updated.type], { id: updated.id });

			if (view) {
				angular.extend(view, updated);
			}
		});

		$scope.$on('listView.deleted', function (e, deleted) {
			var index = _.findIndex(Main.listViews[deleted.type], { id: deleted.id });

			if (index !== -1) {
				Main.listViews[deleted.type].splice(index, 1);
			}
		});

		$scope.$on('self.updated', function (e, self) {
			Main.self = $scope.self = self;
		});

		$scope.$on(Ads.eventPrefix + '.' + Ads.events.accountCreated, function (e, created) {
			if (created && created.active) {
				Main.adActivated = created;
				AppService.setAdAccount(Main.adActivated);
			}
		});

		$scope.$on('standardIntegrationUser.updated', function (e, updated) {
			const { userSettings, masterIntegration: integration } = updated;

			if (integration.userOnly) {
				const userIndex = _.findIndex(Main.userConfigurableIntegrations, { id: integration.id });

				if (userSettings.active && userIndex === -1) {
					Main.userConfigurableIntegrations.push({
						id: integration.id,
						name: integration.name,
						color: integration.color,
						imageLink: integration.imageLink
					});
					Main.userConfigurableIntegrations = _.sortBy(Main.userConfigurableIntegrations, 'name');
				} else if (!userSettings.active && userIndex > -1) {
					Main.userConfigurableIntegrations.splice(userIndex, 1);
				}
			}
		});

		$scope.$on('standardIntegration.updated', function (e, updated) {
			var isActive = updated.active;
			var index;

			StandardIntegration.customer(Main.customerId)
				.get(updated.integrationId)
				.then(function (res) {
					if (res.data.userConfigurable) {
						if (isActive) {
							index = _.findIndex(Main.userConfigurableIntegrations, { id: res.data.id });
							if (index === -1) {
								Main.userConfigurableIntegrations.push({ id: res.data.id, name: res.data.name });
							}
						} else {
							index = _.findIndex(Main.userConfigurableIntegrations, { id: res.data.id });
							if (index !== -1) {
								Main.userConfigurableIntegrations.splice(index, 1);
							}
						}
					}
				})
				.catch(error => {
					logError(error, 'ui/app/upsales/main.js $on standardIntegration.updated');
				});
		});

		// Angular still needs to set some variables on login. This will get less and less as we port stuff
		$scope.$on('react.loginDone', (_e, { allIWant, adsAccount, scripts, staticValues }) => {
			Main.customerId = $scope.customerId = allIWant.self.client.id;
			Main.self = $scope.self = allIWant.customerSelf;
			Main.upsalesVersion = allIWant.metadata.version;
			Main.licenses = allIWant.metadata.licenses;
			Main.mailActivated = allIWant.metadata.map.mailActivated;
			Main.trackingActivated = allIWant.metadata.map.tracking;
			Main.isAdmin = Main.self.administrator;
			Main.isMailAdmin = Main.self.userParams.mailAdmin;
			Main.listViews = allIWant.listViews;
			Main.userMultiSoliditet = Main.self.administrator || Main.self.userParams.multiSoliditetAccess;
			Main.agreementEnabled = allIWant.metadata.params.AgreementEnabled;
			Main.adActivated = adsAccount && adsAccount.active ? adsAccount : null;
			Main.userConfigurableIntegrations = allIWant.metadata.integrations.userConfigurable;
			Main.features = self.features;
			Main.products = self.products;
			Main.version = self.version;

			Main.isLoggedIn = true;

			Tools.AppService.setLoaded();
			Tools.AppService.setIsLoggedIn(true);
			ScriptService.upsales.init();

			AppService.setStaticValuesPromise(Promise.resolve({ data: staticValues }));

			// damn scripts that need the scope
			if (
				!Tools.FeatureHelper.hasSoftDeployAccess('TRACK_DOUBLE_LOGIN_ISSUE') &&
				!document.querySelector('.ng-scope') &&
				scripts?.length &&
				scripts.some(({ code = '', active } = {}) => {
					return active && code.includes('scope()');
				})
			) {
				Store.dispatch(setLoading(true));

				angular.reloadWithDebugInfo();
			}

			// Tell the react login page that angular is done
			$rootScope.$broadcast('angular.loginDone');
		});

		window.addEventListener('offline', function () {
			$scope.$apply();
			NotificationService.addNotification({
				title: 'default.error.connectionLost.title',
				body: 'default.error.connectionLost.body',
				style: 'Error',
				icon: 'times'
			});
		});

		$scope.$on('upsales.logout', clearData);

		$scope.$on('UpsalesSessionExpireWarning', function () {
			if (Main.loginWarningOpen) {
				return; // do not open any more warnings
			}
			Main.loginWarningOpen = true;
			PushNotifications.destroy();
			Store.dispatch(setAIChatOpen(false));

			openModal('SessionExpireWarning', {
				onClose: authed => {
					if (authed) {
						var metadata = AppService.getMetadata();
						// Re-auth pusher
						PushNotifications.customer(Main.customerId).init(Main.self.id, metadata);
					} else {
						security.logout(true);
					}
					Main.loginWarningOpen = false;
				}
			});
		});
	}
]);
